/* tslint:disable */
var UniSlipTemplate = function (uniSlip)
{
    var api = <any>{},
        footerElement, footerTimeout,
        preventNextRedraw = false,
        wrapper = { listener: {}, purchase: {}, lastSelection: {} };

    var updateTabs = function (currentMode, modes, purchases)
    {
        var tabsElement = document.getElementById("idBetsTabs");
        if (!tabsElement)
        {
            return;
        }

        var tabs = tabsElement.children,
            tabElement, mode, i, len;

        for (i = 0, len = tabs.length; i < len; i += 1)
        {
            tabElement = tabs[i];
            mode = modes[tabElement.dataset ? tabElement.dataset.id : tabElement.getAttribute("data-id")];

            if (uniSlip.isBetInProcess)
            {
                updatePurchaseTab(tabElement, mode, purchases);
            }
            else
            {
                updateTab(tabElement, mode);
            }
        }
    };

    var updateTab = function (tabElement, mode)
    {
        tabElement.classList[mode.canActivate() ? "remove" : "add"](mode.IsInvisibleModeOn ? "isHidden" : "inactive");
        tabElement.classList[mode.Active ? "add" : "remove"]("active");
    };

    var updatePurchaseTab = function (tabElement, mode, purchases)
    {
        var isCurrent = mode.IsBetInProcess || (purchases.length && mode === purchases[0].Mode);
        tabElement.classList[isCurrent ? "remove" : "add"]("inactive");
        tabElement.classList[isCurrent ? "add" : "remove"]("active");
    };

    // Transform and return current selection type by existing propery "betType" of each selection

    var buildSelections = function (mode, selections)
    {
        selections = sortSelections(selections, mode);
        mode.isFirstSelection = true;
        var selection, i;

        var __html = '';
        for (i = 0; i < selections.length; i+=1)
        {
            selection = selections[i];
            if (PulseBettingEventTypeIds[selection.EventTypeID])
            {
                continue;
            }

            __html += buildLineHeader(selection, selections[i - 1], mode);
            var context = Modes.isTeaserMode(mode) ? mode.getTeaserContext() : {};
            __html += TBuildLine.buildView(selection, mode, context);
            __html += buildLineSummary(selection, selections[i + 1], mode);
        }

        mode.CurrentError = !__html.length ? $dict.bs("NoSelectionsTablet") : mode.CurrentError !== $dict.bs("NoSelectionsTablet") && mode.CurrentError;
        return __html;
    };

    function buildLineHeader(selection, prevSelection, mode)
    {
        if (Modes.isCombinatorMode(mode))
        {
            return buildCombinatorGroupHeader(selection, prevSelection, mode);
        }

        return '';
    }

    function buildLineSummary(selection, nextSelection, mode)
    {
        if (Modes.isCombinatorMode(mode))
        {
            return buildCombinatorGroup(selection, nextSelection, mode);
        }

        return '';
    }

    function buildCombinatorGroupHeader(selection, prevSelection, mode)
    {
        var groupsCount = mode.CombinatorGroups && Array.getKeys(mode.CombinatorGroups).length,
            prevGroup = prevSelection && prevSelection.CombinatorGroup;

        if (groupsCount > 1 && Array.getKeys(mode.getSelectionsInCombo()).length > 0 && selection.CombinatorGroup)
        {
            if (prevGroup !== selection.CombinatorGroup)
            {
                return TBuildGroup.buildHeader(selection.CombinatorGroup);
            }
        }

        return '';
    }

    function buildCombinatorGroup(selection, nextSelection, mode)
    {
        var groupsCount = mode.CombinatorGroups && Array.getKeys(mode.CombinatorGroups).length,
            nextGroup = nextSelection && nextSelection.CombinatorGroup;

        if (groupsCount > 1 && Array.getKeys(mode.getSelectionsInCombo()).length > 0 && selection.CombinatorGroup)
        {
            if (nextGroup !== selection.CombinatorGroup)
            {
                return TBuildGroup.buildView(selection.CombinatorGroup, mode.getGroupOdd(selection.CombinatorGroup));
            }
        }

        return '';
    }

    function sortSelections(selections, mode)
    {
        if (Modes.isCombinatorMode(mode))
        {
            selections.sort(function (a, b) { return a.compareCombinatorGroup(b, true); });
        }

        return selections;
    }

    var buildOptions = function (modes, selections)
    {
        var mode, i, len,
            keys = Object.keys(modes);

        var __html = '';
        for (i = 0, len = keys.length; i < len; i += 1)
        {
            mode = modes[keys[i]];

            if (mode.Active)
            {
                __html += mode.buildOptions(selections);
            }
        }

        return __html;
    };

    var updateStatusElement = function (mode, selections)
    {
        var __html = '',
            lastSelection = selections[selections.length - 1];

        if (!lastSelection) { return; }

        var lastElement = document.getElementById("sce_" + lastSelection.ViewKey);
        var lastgroup = document.getElementById("gsce_" + lastSelection.CombinatorGroup);

        lastElement = lastgroup ? lastgroup : lastElement;

        if (lastElement)
        {
            if (Modes.isSingleMode(mode) || !mode.IsBetInProcess)
            {
                if (Modes.isSingleMode(mode) && !mode.ShowLastLineError)
                {
                    return;
                }

                if (mode.IsUKBetSlip && mode.IsBetInProcess)
                {
                    __html += TSlipShared.createMessage($dict.bs("BetInProcess"), "positive");
                    __html += TSlipShared.createBonusBettingMessage(mode);
                }

                if (!mode.Errors.contains(mode.CurrentError))
                {
                    __html += TSlipShared.createMessage(mode.CurrentError, "negative");
                }
            }
            else
            {
                __html += TSlipShared.createMessage($dict.bs("BetInProcess"), "positive");
                __html += TSlipShared.createBonusBettingMessage(mode);
            }

            lastElement.insertAdjacentHTML("beforeend", __html);
        }
    };

    var updateControlElements = function (mode, selections)
    {
        var rootElement = document.getElementById("betting_slip");

        if (!rootElement)
        {
            return;
        }

        var controls = rootElement.querySelectorAll("input, button, a"),
            control, i = controls.length, disabled = mode.IsBetInProcess;

        while (i > 0)
        {
            i -= 1;

            control = controls[i];
            if (control.classList.contains("stakeboxActionsMinus") && !disabled) { continue; }

            control.disabled = disabled;
            control.classList[disabled ? "add" : "remove"]("inactive");
        }

        updateStatusElement(mode, selections);
    };

    uniSlip.OnUpdate = {};

    api.buildPurchases = function ()
    {
        var mode = uniSlip.PlaceBetsMode, purchase,
            purchases = Array.getValues(uniSlip.Purchases),
            i = purchases.length;

        while (i > 0)
        {
            i -= 1;
            purchase = purchases[i];

            purchase.Mode = purchase.Mode || mode;
        }

        api.buildView();
    };

    var buildPurchases = function (mode, purchases)
    {
        var __html = '',
            purchase, i = purchases.length,
            purchaseActionsArea = document.getElementById("idBetSlipActionsArea"),
            purchaseActionsElement = document.getElementById("idBetsPurchaseActions");

        if (purchaseActionsArea)
        {
            purchaseActionsArea.classList.add("isHidden");
        }

        if (purchaseActionsElement)
        {
            purchaseActionsElement.classList.add("isHidden");
        }
        
        while (i > 0)
        {
            i -= 1;
            purchase = purchases[i];

            if (purchase.PurchaseTypeID === SPPurchaseType.PulseBet || purchase.PurchaseTypeID === SPPurchaseType.YourBet)
            {
                continue;
            }
            api.updatePurchaseActions(purchase);
            __html += TPurchases.buildView(purchase.Mode || mode, purchase, {});
        }

        return __html;
    };

    var updateStakeboxValues = function (input)
    {
        var parent = input.parentElement,
            minusButton = parent.parentElement.querySelector(".stakeboxActionsMinus"),
            disabled = input.value <= Bets.getMinStakeValue();

        minusButton.classList[disabled ? "add" : "remove"]("inactive");
    };

    api.updateStakeboxValues = function (input)
    {
        var setStakeForAllInput = document.getElementById("setStakeForAll");

        updateStakeboxValues(input);
        if (setStakeForAllInput)
        {
            updateStakeboxValues(setStakeForAllInput);
        }
    };

    api.updateAllVisibleStakeboxValues = function (input)
    {
        var minusButtons = document.getElementsByClassName("stakeboxActionsMinus"),
            disabled = input.value <= Bets.getMinStakeValue(),
            i = minusButtons.length;

        while (i > 0)
        {
            i -= 1;
            minusButtons[i].classList[disabled ? "add" : "remove"]("inactive");
        }
    };

    var initFooterElement = function ()
    {
        footerElement = footerElement || document.getElementById("footerlink_bs_count");

        return footerElement;
    };

    var getSelectionCount = function (selectionCount)
    {       
        var purchasesCount = Array.getLength(uniSlip.Purchases.where(function (purchase) {
            return !(purchase instanceof SPCashOutPurchase) && purchase.PurchaseTypeID != SPPurchaseType.PulseBet && purchase.PurchaseTypeID != SPPurchaseType.YourBet;
        }));
        return +selectionCount || uniSlip.getSelectionsCount() || purchasesCount;
    };
    
    api.updateCounter = rafPaint(function (selectionCount, updatedCount)
    {
        if (initFooterElement() && showBetCountIcon())
        {
            selectionCount = getSelectionCount(selectionCount);
            setDomText(footerElement, selectionCount);

            var panel = UniSlipBlock.getPanel();
            var shouldHide = panel && panel.isSidePanel() && panel.expanded;

            if (selectionCount > 0 && !shouldHide)
            {
                addCounterAnimation(updatedCount);
                document.body.classList.add("footerBettingVisible");
            }
            else
            {
                document.body.classList.remove("footerBettingVisible");
            }
        }
        else
        {
            document.body.classList.remove("footerBettingVisible");
        }
    });

    var showBetCountIcon = function ()
    {
        var betSlipPosition = UniSlipBlock.getPanelPosition();

        if (!UniSlipBlock.isActive && (betSlipPosition == PanelPosition.CENTER || betSlipPosition == PanelPosition.POPUP))
        {
            return true;
        }

        if (UniSlipBlock.isActive && (betSlipPosition == PanelPosition.LEFT || betSlipPosition == PanelPosition.RIGHT))
        {
            return true;
        }

        return false;
    };

    var addCounterAnimation = function (updatedCount)
    {
        if (!updatedCount || typeof updatedCount === "object") { return; }

        footerElement.classList.add("updated");

        if (updatedCount !== "forced")
        {
            clearTimeout(footerTimeout);
            footerTimeout = setTimeout(api.removeCounterAnimation, 1500);
        }
    };

    api.removeCounterAnimation = function ()
    {
        if (initFooterElement())
        {
            footerElement.classList.remove("updated");
        }
    };

    api.updatePurchaseActions = function (purchase)
    {
        var lastLeagueButton = document.getElementById("idLastBetLegueBtn"),
            purchaseActionsArea = document.getElementById("idBetSlipActionsArea"),
            purchaseActionsElement = document.getElementById("idBetsPurchaseActions");

        if (!purchase.Final && !purchase.getExpanded())
        {
            return;
        }

        if (purchase.Final)
        {
            if (purchaseActionsArea && !purchase.IsCashOutRequest)
            {
                purchaseActionsArea.classList.remove("isHidden");
            }

            if (purchaseActionsElement && !purchase.IsCashOutRequest)
            {
                purchaseActionsElement.classList.remove("isHidden");
            }

            if (lastLeagueButton)
            {
                updateLastLeagueButton(purchase);
            }
        }

        api.updateCounter(Array.getLength(uniSlip.Selections), "forced");
    };

    function getLeagueName(selection, purchase)
    {
        if (selection.LeagueName === undefined && selection instanceof MultiLineItem)
        {
            return purchase.Selections[0].LeagueName;
        }

        return selection.LeagueName;
    }

    // Returns false if can"t redirect to horse branch or true if redirect is Ok
    function redirectToBranchPanel(ev, purchase, lastSelection)
    {
        var selections = purchase.getSelections();
        if (lastSelection instanceof MultiLineItem && (selections[lastSelection.Selections[0]].BranchID === constHorseRacingBranchID || selections[lastSelection.Selections[0]].BranchID == constGreyHoundRacingBranchID))
        {
            var branchID = selections[lastSelection.Selections[0]].BranchID;
            var locationHash = selections[lastSelection.Selections[0]].LocationHash;
            if (UseAustralianHorseRacingView && locationHash)
            {
                Application.navigateToHash(locationHash);
            } else
            {
                Application.OpenBranchPanel(ev, branchID);
            }
            return true;
        }

        return false;
    }

    // Onclick event listener for last league
    function addLastEventListener(wrapper, event)
    {
        event.preventDefault();

        if (!redirectToBranchPanel(event, wrapper.purchase, wrapper.lastSelection))
        {
            getLastLeaguePanelHandler(wrapper.lastSelection);
            var rightPanel = Application.getRightPanel();
            rightPanel && rightPanel.leave(); 
        }
    }

    function addLiveEventListener()
    {
        Application.goHome();
        var rightPanel = Application.getRightPanel();
        rightPanel && rightPanel.leave();
    }

    var updateLastLeagueButton = function (purchase)
    {
        var lastLeagueButton = document.getElementById("idLastBetLegueBtn");
        var lastSelection = purchase.getSelections().slice(-1)[0];
        if (!lastSelection || !lastLeagueButton)
        {
            return;
        }

        lastLeagueButton.removeEventListener("click", wrapper.listener as EventListener, false);
        if (lastSelection.Live)
        {
            setDomText(lastLeagueButton, $dict.bs("GoToLiveMobile"));
            wrapper.listener = addLiveEventListener;
        }
        else
        {
            wrapper.purchase = purchase;
            wrapper.lastSelection = lastSelection;
            wrapper.listener = addLastEventListener.bind(this, wrapper);

            setDomText(lastLeagueButton, getLeagueName(wrapper.lastSelection, purchase));
        }

        lastLeagueButton.addEventListener("click", wrapper.listener as EventListener, false);
    };

    /*globals constHorseRacingBranchID, constGreyHoundRacingBranchID, RacingBranchBlock*//*jshint newcap: false */
    function getLastLeaguePanelHandler(lastSelection)
    {
        if (lastSelection.BranchID === constHorseRacingBranchID || lastSelection.BranchID == constGreyHoundRacingBranchID)
        {
            RacingBranchBlock.Current.navigateTo(lastSelection.BranchID, lastSelection.LeagueID, lastSelection.RacingRegionID, lastSelection.RacingMode);
        }
        else
        {
            Application.OpenLeague(event, lastSelection.LeagueID, lastSelection.BranchID);
        }
    }
    /*jshint newcap: true */

    api.preventNextRedraw = function ()
    {
        preventNextRedraw = true;
    };

    function validatePurchases(purchases)
    {
        return purchases.length === 0 ?  true : hasSPCashOutPurchaseOnly(purchases);
    }

    //check if there are only SPCashOutPurchase types
    function hasSPCashOutPurchaseOnly(purchases)
    {
        var SPCashOutPurchases = purchases.filter(function(val) {
            return val instanceof SPCashOutPurchase;
        });

        return SPCashOutPurchases.length > 0 && SPCashOutPurchases.length === purchases.length;
    }

    
    var buildView = function ()
    {
        var __html = '',
            mode = uniSlip.CurrentMode, modes,
            purchases = Array.getValues(uniSlip.Purchases),
            selections = Array.getValues(uniSlip.Selections),
            uniSlipMessageElement = document.getElementById("unislip_no_selections"),
            betSlipSelections = document.getElementById("betslip-body-wrapper"),
            lastSelectionCount = +StorageUtils.getFromStorage("lastSelectionCount", sessionStorage) || 0,
            selectionCount = uniSlip.getSelectionsCount(),
            activeElementID = (document.activeElement && document.activeElement.tagName && document.activeElement.tagName.toLowerCase() === "input") ? document.activeElement.id : "",
            activeElementValue = (document.activeElement && document.activeElement.tagName && document.activeElement.tagName.toLowerCase() === "input") ? (document.activeElement as HTMLInputElement).value : "",
            rootElement = document.getElementById("betting_slip"),
            redrawElement = document.getElementById("idBetsSelections");
        if (mode instanceof PulseSPSlipMode)
        {
            return;
        }
        //no selections and no valid purchase types
        if (selectionCount === 0 && validatePurchases(purchases))
        {
            if (uniSlipMessageElement && betSlipSelections)
            {
                uniSlipMessageElement.classList.remove("isHidden");
                betSlipSelections.classList.add("isHidden");
            }            
        }
        else
        {
            if (uniSlipMessageElement && betSlipSelections)
            {
                uniSlipMessageElement.classList.add("isHidden");
                betSlipSelections.classList.remove("isHidden");
            }            
        }

        if (typeof UniSlipBlock != "undefined" && UniSlipBlock.isActive && !preventNextRedraw)
        {
            modes = Array.getValues(uniSlip.Modes);

            if (mode.manageNoComboSelectionFlags)
            {
                mode.manageNoComboSelectionFlags();
            }

            __html += buildPurchases(mode, purchases);
            __html += buildSelections(mode, selections);
            __html += buildOptions(modes, selections);
            __html += TSlipShared.buildMaxBetMessage(mode, selections);
            if (redrawElement) { 
                redrawElement.innerHTML = __html;
            }

            updateControlElements(mode, selections);

            if (!IsUKBetSlip)
            {
                updateTabs(mode, uniSlip.Modes, purchases);
            }
            else if (rootElement)
            {
                if (selectionCount > 1)
                {
                    rootElement.classList.add("ukSlip--multi");
                }
                else
                {
                    rootElement.classList.remove("ukSlip--multi");
                }
            }
            uniSlip.toggleBetReceiptBanner(selections.length > 0);
            uniSlip.updateBSFooterImmediate();
            toggleSingleSelectionClass(redrawElement, selectionCount);
            buildBookABet();
        }

        preventNextRedraw = false;

        var element = document.getElementById(activeElementID) as any;
        if (typeof element != "undefined" && element !== null)
        {
            element.focus();
            element.value = activeElementValue;
        }
        
        StorageUtils.saveToStorage("lastSelectionCount", selectionCount, sessionStorage);
        executeEvents(uniSlip.OnUpdate, selectionCount, selectionCount > lastSelectionCount);
        executeEvents(uniSlip.OnViewUpdated);
    }

    function buildBookABet()
    {
        var redrawElement = document.getElementById("book-a-bet-container");
        if (redrawElement) {
            redrawElement.innerHTML = TSlipShared.buildBookABet();
        }
    }
    
    function toggleSingleSelectionClass(redrawElement, selectionCount)
    {
        redrawElement.classList[BetSlipUtil.isSingleSelection(selectionCount) ? "add" : "remove"]("single-selection");
    }

    /*jshint maxcomplexity: 5 */

    api.buildViewImmediate = function ()
    {
        preventNextRedraw = false;
        buildView();
        api.preventNextRedraw();
    };

    api.buildView = debounce(buildView, 10);

    // private
    api._updateTabs = updateTabs;
    api._buildSelections = buildSelections;
    api._buildOptions = buildOptions;

    return api;
};

window.UniSlipTemplate = UniSlipTemplate;